import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from 'src/environments/environment';
import {GeocoderResponse} from "../models/geocoder-response";
import {catchError, map, Observable} from "rxjs";
import {Address} from "../models/address";

@Injectable({
  providedIn: 'root'
})
export class GeocodingService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * Turns address into coordinates using the Google Maps Geocoding API.
   * @param address - Dutch address (e.g., 'Langestraat 56, 1811 JJ Alkmaar').
   * @returns An Observable with geocoding info.
   */
  addressToCoords(address: Address): Observable<GeocoderResponse> {
    const searchTerm = `${address.streetName} ${address.houseNumber}, ${address.zipcode} ${address.location}`
    const url = `https://maps.google.com/maps/api/geocode/json?address=${searchTerm}&sensor=false&key=${environment.googleApiKey}`;

    return this.http.get<GeocoderResponse>(url);
  }

  /**
   * Fetches street name and city from PDOK API using postal code and house number.
   * @param postalCode - The Dutch postal code (e.g., '1012AB').
   * @param houseNumber - The house number (e.g., '10').
   * @returns An Observable with street and city info or an error.
   */
  fetchAddressFromPDOK(postalCode: string, houseNumber: string): Observable<{ street: string; city: string }> {
    const query = `${postalCode} ${houseNumber}`;
    const pdokApiUrl = `https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?q=${query}&fl=straatnaam,woonplaatsnaam`;

    return this.http.get<any>(pdokApiUrl).pipe(
      map((response) => {
        if (response.response.numFound > 0) {
          const address = response.response.docs[0];
          return {
            street: address.straatnaam,
            city: address.woonplaatsnaam
          };
        } else {
          throw new Error('Address not found');
        }
      }),
      catchError((error) => {
        console.error('PDOK API Error:', error);
        throw error;
      })
    );
  }
}
